import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Globals } from 'src/app/globals';
import { TranslateService } from '@ngx-translate/core';
import { UserService } from 'src/app/service/user.service';
import { RoleService } from 'src/app/service/role.service';
import { OrgService } from 'src/app/service/org.service';
import { CoursesService } from 'src/app/service/courses.service';
import { ScheduleService } from 'src/app/service/schedule.service';
@Component({
  selector: 'app-schedule-setup-create',
  templateUrl: './schedule-setup-create.component.html',
  styleUrls: ['./schedule-setup-create.component.scss']
})
export class ScheduleSetupCreateComponent implements OnInit {

  showLoader: boolean = false;
  creating: boolean = false;

  createScheduleSetup = new FormGroup({
    effectiveDateFrom: new FormControl('', [
      Validators.required,
    ]),
    effectiveDateTo: new FormControl('', [
      // Validators.required, 
    ]),
    timeSlot: new FormControl('', [
      Validators.required,
    ]),
    // breakTimeSlot: new FormControl('', [
    //   Validators.required,
    // ]),
    weekStarts: new FormControl('', [
      Validators.required,

    ]),
    saturday: new FormControl('', [
      Validators.required,
    ]),
    sunday: new FormControl('', [
      Validators.required,
    ]),
    monday: new FormControl('', [
      Validators.required,
    ]),
    tuesday: new FormControl('', [
      Validators.required,
    ]),
    wednesday: new FormControl('', [
      Validators.required,
    ]),
    thursday: new FormControl('', [
      Validators.required,
    ]),
    friday: new FormControl('', [
      Validators.required,
    ]),
    remarks: new FormControl('', [
      // Validators.required,
    ]),
    active: new FormControl('', [
      Validators.required,
    ]),
  });

  constructor(
    private toastrService: ToastrService, public globals: Globals, private toastr: ToastrService, private activatedRoute: ActivatedRoute, private router: Router, public translate: TranslateService, public scheduleService: ScheduleService
  ) {

  }

  ngOnInit(): void { }

  createScheduleSetupChange() {
    // let classHours = this.createScheduleSetup.controls.classHours.value;
    // let clinicalHours = this.createScheduleSetup.controls.clinicalHours.value;
    // this.createScheduleSetup.controls.totalHours.setValue(Number(classHours) + Number(clinicalHours));
  }

  createScheduleSetupSubmit() {
    if (this.createScheduleSetup.valid) {
      this.addSchedule(this.createScheduleSetup.controls.effectiveDateFrom.value, this.createScheduleSetup.controls.effectiveDateTo.value, this.createScheduleSetup.controls.timeSlot.value, "0", this.createScheduleSetup.controls.sunday.value, this.createScheduleSetup.controls.monday.value, this.createScheduleSetup.controls.tuesday.value, this.createScheduleSetup.controls.wednesday.value, this.createScheduleSetup.controls.thursday.value, this.createScheduleSetup.controls.friday.value, this.createScheduleSetup.controls.saturday.value, this.createScheduleSetup.controls.weekStarts.value, this.createScheduleSetup.controls.remarks.value);
    } else {
      this.createScheduleSetup.markAllAsTouched();
      this.createScheduleSetup.markAsDirty();
    }
  }

  addSchedule(effectiveFrom: string, effectiveTo: string, periodTimeSlot: string, breakTimeSlot: string, timeSlotSun: any, timeSlotMon: any, timeSlotTue: any, timeSlotWed: any, timeSlotThu: any, timeSlotFri: any, timeSlotSat: any, weekStart: any, remarks: any) {
    this.creating = true;
    let username = this.globals.currentUserInfo.username;
    let orgId = this.globals.currentUserInfo.orgid;

    this.scheduleService.addSchedule(username, orgId, effectiveFrom, effectiveTo, periodTimeSlot, breakTimeSlot, timeSlotSun, timeSlotMon, timeSlotTue, timeSlotWed, timeSlotThu, timeSlotFri, timeSlotSat, weekStart, remarks)
      .subscribe(
        data => {
          if (data.sts == "SUCCESS") {
            this.toastrService.success(this.translate.instant('ADDED_SUCCESSFULLY'));
            this.router.navigate(['/schedule/schedule-setup']);
          } else {
            this.creating = false;
            this.toastrService.error(this.translate.instant('FAIL_TO_CREATE'));
          }
        },
        error => {
          this.creating = false;
          this.toastrService.error(this.translate.instant('FAIL_TO_CREATE'));
        }
      );
  }
}

